import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { useResponsiveUrl } from './utils';
import { containerOffset, CoverImage, CoverWrapper, GradientX, GradientY } from './HeaderCover';
import { BreakPointsOnly } from './theme';
import { mainBg } from './styles/Main';

export const Container = styled.section<{ customContentOffset?: BreakPointsOnly }>(({ theme }) => ({
  color: theme.palette.foreground[900][0],
  backgroundColor: theme.palette.background[mainBg][0],
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '-2rem',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    marginBottom: '-21rem',
  },
  [theme.breakpoints.between('md', 'lg')]: {
    marginBottom: '-26rem',
  },
  [theme.breakpoints.between('lg', 'xl')]: {
    marginBottom: '-31rem',
  },
  [theme.breakpoints.up('xl')]: {
    marginBottom: '-41rem',
  },
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-end',
  },
}));

export type HeaderCoverProps = {
  image?: string;
};

const CinemaLandingHeaderCover = forwardRef<HTMLDivElement, HeaderCoverProps>(function HeaderCover({ image }, ref) {
  const imgUrl = useResponsiveUrl({ url: image, desktop: 1920, mobile: 880 });

  return (
    <Container className="header-cover" ref={ref} customContentOffset={containerOffset} >
      <CoverWrapper>
        <CoverImage style={{ backgroundImage: `url(${imgUrl})` }}>
          <GradientX />
          <GradientY />
        </CoverImage>
      </CoverWrapper>
    </Container>
  );
});

export default CinemaLandingHeaderCover;
